@use '@/styles/tokens' as *;

// Figma 401:273008 draws a fixed 550px modal: 102 header band + 448 body-and-footer. With the shared
// chrome's 24px body padding and 80px footer region, 320px here lands the total on 550 and keeps the
// footer from moving between steps 1 and 2, which hold the same two-field row.
.stepBody {
  min-height: 320px;
}

// Two equal columns, drawn as two 300px fields in a 613px row. Step 1 holds Select Device + Serial
// Number, step 2 holds DM Category + Parameter Template — the same grid, which is why the footer does
// not shift between them.
.fieldRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
}

// The category/device mismatch message (AC8). Undrawn: frame 216:266069 *is* the mismatch state and
// carries no error text — and reddens neither field, which is why no `status="error"` is set. So it
// takes the shared field-error treatment from `FormField .error` (11px / 300 / error-900), matching the
// serial-length error one step earlier, and sits under the row because it is about the pair.
.mismatch {
  margin: 0;
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}

// Step 3's confirmation panel. **Undrawn**: Figma 216:261822 draws a 205px cream tab rail and six
// label/description/value rows, and this ticket deliberately builds neither — the tab names, field
// labels and enum option labels live only in the Digital Matter parameter dictionary, which no endpoint
// serves. So the panel takes the shipped centred-panel idiom from `replacement-requests-drawer .empty`
// rather than inventing one.
//
// 422px is derived, not chosen: the frame's body region is 470px and the shared chrome's body carries
// 24px of padding on each side, so this keeps the card at its drawn 906×676 and keeps the footer still
// between Step 2 and Step 3 — exactly what `.stepBody`'s 320px does for steps 1 and 2. `min-height`
// rather than `height` so a long template name wrapping the summary line cannot clip the panel.
.applied {
  display: flex;
  min-height: 422px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  text-align: center;
}

// The app's success green — the `approved` chip's text colour, and `Brand/700` in this frame's own
// Figma variables. Not the `.emptyIcon` opacity-0.3 treatment the drawer uses: that reads as absence,
// and this is a success.
.appliedIcon {
  color: $color-brand-700;
}

.appliedHeading {
  margin: 0;
  font-size: $font-size-lg;
  font-weight: $font-weight-medium;
  color: var(--text-primary);
}

.appliedDetail {
  margin: 0;
  font-size: $font-size-md;
  color: var(--text-muted);
}
